import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	FLAGGED_CF_TYPE,
	MULTI_CHECKBOXES_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

const transformJiraFlagToLegacyFlag = (flag?: { isFlagged?: boolean | null } | null) => {
	if (flag == null || flag.isFlagged == null) {
		return null;
	}

	return [
		{
			value: flag.isFlagged,
		},
	];
};

export const transformAggFlagToLegacyField: FieldTransformer<typeof FLAGGED_CF_TYPE> = (node) => {
	// Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
	if (node.type !== MULTI_CHECKBOXES_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformJiraFlagToLegacyFlag(node.flag),
		schema: {
			configuration: null,
			custom: FLAGGED_CF_TYPE,
			items: 'option',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
